<template >
  <div class="col" :class="[widthClass, offsetClass, pushClass, pullClass]">
    <template v-for="component in ctx.components">
      <component
        :is="component.type"
        :key="component.key"
        :theme="theme"
        :ctx-a="component"
        :store="store"
      ></component>
    </template>
  </div>
</template>

<script>
import SimpleComponentMixin from '../../mixins/SimpleComponentMixin';

export const defaultSchema = {
  components: [],
  width: 6,
  offset: 0,
  push: 0,
  pull: 0
};

export default {
  name: 'single-column',
  mixins: [SimpleComponentMixin],
  beforeCreate() {
    this.defaultSchema = defaultSchema;
  },
  computed: {
    widthClass() {
      return `col-md-${this.ctx.width}`;
    },
    offsetClass() {
      return `col-md-offset-${this.ctx.offset}`;
    },
    pushClass() {
      return `col-md-push-${this.ctx.push}`;
    },
    pullClass() {
      return `col-md-pull${this.ctx.pull}`;
    }
  }
};
</script>
